import o from "react";
import s from "./storyblok-component.mjs";
import { BlockTypes as m, richTextResolver as a } from "./storyblok-js.mjs";
function i(e) {
  var t, n;
  const r = (t = e == null ? void 0 : e.attrs) == null ? void 0 : t.body;
  return o.createElement(s, {
    blok: Array.isArray(r) ? r[0] : void 0,
    key: (n = e.attrs) == null ? void 0 : n.id
  });
}
function p(e) {
  const r = {
    renderFn: o.createElement,
    textFn: (t) => o.createElement(o.Fragment, {
      key: Math.random().toString(36).substring(2, 15)
    }, t),
    resolvers: {
      [m.COMPONENT]: i,
      ...e.resolvers
    },
    keyedResolvers: !0
  };
  return a(r);
}
export {
  i as componentResolver,
  p as useStoryblokRichText
};
